export const FISCAL_REVIEW_STATES = Object.freeze({
  pending: 'Pendiente de revision',
  under_review: 'En revision',
  requires_correction: 'Requiere correccion',
  reviewed: 'Revision administrativa completa',
  draft: 'Sin aviso vigente',
  legacy_review: 'Revision anterior; sin prueba tecnica',
  revoked: 'Revocada',
  inactive: 'Registro inactivo',
});

export const FISCAL_REVIEW_DECISIONS = ['under_review', 'requires_correction', 'reviewed'];

export const getCurrentFiscalReview = (issuer) => {
  const review = issuer?.metadata?.onboardingReview;
  return issuer?.delegationStatus === 'pending' && issuer?.metadata?.verificationRequestedAt &&
    review?.requestedAt === issuer.metadata.verificationRequestedAt && FISCAL_REVIEW_DECISIONS.includes(review.status)
    ? review : null;
};

export const getFiscalReviewState = (issuer) => {
  if (issuer?.active === false) return 'inactive';
  if (issuer?.delegationStatus === 'revoked') return 'revoked';
  if (!issuer || issuer.delegationStatus === 'not_started' || !issuer.metadata?.verificationRequestedAt) return 'draft';
  if (issuer.delegationStatus === 'verified') return 'legacy_review';
  if (issuer.delegationStatus === 'error') return 'requires_correction';
  return getCurrentFiscalReview(issuer)?.status || 'pending';
};

export const validateFiscalReview = ({ status, message = '' }) => {
  if (!FISCAL_REVIEW_DECISIONS.includes(status)) return 'Selecciona un estado de revision valido.';
  if (message.trim().length > 1500) return 'La observacion no puede superar los 1500 caracteres.';
  if (status === 'requires_correction' && !message.trim()) return 'Indica que debe corregir el restaurante.';
  return '';
};
